module.exports = __webpack_public_path__ + "img/tom.c75a219.svg";